import React from 'react'

export default function NtpBenefits() {
  return (
    <div>
         <div class="how_it_work style_three pt-80 pb-10">
      <div class="container">
        <div class="row">
          {/* <!-- Start Section Tile --> */}
          <div class="col-lg-12">
            <div class="section_title text_center mb-90 mt-3">
             
              <div class="section_main_title">
                <h2>Benefits of<span> Next Tech Purchase<sup>&reg;</sup></span></h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="single_how_it_work text-center mb-60 wow flipInY" data-wow-delay="0ms" data-wow-duration="1500ms pl-3 pr-3">
              <div class="how_it_work_content">
                <div class="how_it_work_number">
                  <h4>01</h4>
                </div>
                <div class="how_it_work_icon">
                  <div class="">
                  <img src="assets/images/shape/market-engagement.svg" alt='stay ahead of the curve'/>
                  </div>
                  <div class="how_it_work_icon_bg_thumb">
                    <div class="how_it_work_icon_bg_thumb_inner">
                      <img src="assets/images/shape/Frame 15.png" alt="frame1"/>
                    </div>
                   
                  </div>
                </div>
                <div class="how_it_work_title pt-65">
                  <h4>Stay ahead of the curve</h4>
                </div>
                <div class="how_it_work_text pt-2">
                  <p>
                  Position offerings ahead of competitors by anticipating and responding to emerging technology adoption trends.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="single_how_it_work text-center pl-3 pr-3 mb-60 wow flipInY" data-wow-delay="0ms" data-wow-duration="1500ms">
              <div class="how_it_work_content">
                <div class="how_it_work_number">
                  <h4>02</h4>
                </div>
                <div class="how_it_work_icon">
                  <div class="">
                  <img src="assets/images/shape/cost-efficiency.svg" alt='cost-efficiency'/>
                  </div>
                  <div class="how_it_work_icon_bg_thumb">
                    <div class="how_it_work_icon_bg_thumb_inner">
                      <img src="assets/images/shape/Frame 15.png" alt="frame2"/>
                    </div>
                    
                  </div>
                </div>
                <div class="how_it_work_title pt-65">
                  <h4>Cost Efficiency</h4>
                </div>
                <div class="how_it_work_text pt-2">
                  <p>
                  Focus efforts on high-propensity accounts to maximize ROI.

                  </p>
                </div>
              </div>
            </div>
          </div>
         
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="single_how_it_work text-center pl-3 pr-3 mb-60 wow flipInY" data-wow-delay="0ms" data-wow-duration="1500ms">
              <div class="how_it_work_content">
                <div class="how_it_work_number">
                  <h4>03</h4>
                </div>
                <div class="how_it_work_icon">
                  <div class="icon">
                  <img src="assets/images/shape/data backed.svg" alt='data backed'/>
                  </div>
                  <div class="how_it_work_icon_bg_thumb">
                    <div class="how_it_work_icon_bg_thumb_inner">
                      <img src="assets/images/shape/Frame 15.png" alt="frame3"/>
                    </div>
                   
                  </div>
                </div>
                <div class="how_it_work_title pt-65">
                  <h4>Data-Backed Decision Making</h4>
                </div>
                <div class="how_it_work_text pt-2">
                  <p>
                  Equip teams with verified insights to guide strategic planning, reduce guesswork, and support data-driven outreach.


                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}
